import { getCountryList } from "../../../api/admin/addressReq";
import useAuth from "../../../hooks/useAuth";
import useData from "../../../hooks/useData";
import { useEffect } from "react";
import { filterCountryList, patternListChoices } from "../../../helper/tools";
import CityNameZipSuggest from "./CityNameZipSuggest";

export default function InputFullAddress({
    onChange, type,
    addressField, compField, zipField, cityField, countryField,
    address, comp, zipcode, city, country, compClass, legendView, legendName, required, event, disabled, readonly }) {
    const { countryList, setCountryList } = useData();
    const selectedCountry = filterCountryList(countryList, country);
    const { auth } = useAuth();
    const token = auth?.token;

    const apiCountryList = async () => {
        const response = await getCountryList(token);
        setCountryList(response);
    }

    useEffect(() => {
        apiCountryList();
    }, [token]);

    const addressFields = (
        <>
            <div className="form-input">
                <label htmlFor={addressField} className={required && !event && "required"}>Adresse</label>
                {!readonly ?
                    <input id={addressField} disabled={disabled} pattern={patternListChoices?.address} type="text" name={addressField} className="address-input" value={address || ""} onChange={onChange} required={event ? "" : required} />
                    : <span>{address}</span>
                }
            </div>
            <div className={compClass == "address_comp_none" ? "address_comp_none form-input" : "form-input"}>
                <label className={compClass} htmlFor={compField}>Complément d'adresse</label>
                {!readonly ?
                    <input id={compField} disabled={disabled} pattern={patternListChoices?.address} className={compClass} type="text" name={compField} value={comp || ""} onChange={onChange} /> :
                    <span>{comp}</span>
                }
            </div>
            {(!readonly && country === "FR") &&
                <CityNameZipSuggest zipField={zipField} cityField={cityField} city={city} zipcode={zipcode} onChange={onChange} type={type} disabled={disabled} />
            }
            {!readonly && country !== "FR" &&
                <div className="form-input">
                    <label className="required" htmlFor={zipField}>Code postal </label>
                    <input id={zipField} name={zipField} value={zipcode || ""} onChange={onChange} type="text" placeholder="Code postal" disabled={disabled} />
                    <label className="required" htmlFor={cityField}>Ville </label>
                    <input id={cityField} name={cityField} value={city || ""} onChange={onChange} type="text" placeholder="Ville" disabled={disabled} />
                </div>
            }
            <div className="form-input">
                <label className={required && "required"} htmlFor={countryField}>Pays</label>
                {!readonly ?
                    <select
                        id={countryField}
                        name={countryField}
                        value={country || "FR"}
                        onChange={onChange}
                        required={required}
                        disabled={disabled}>
                        {countryList?.map((elm, index) => (
                            <option key={index} value={elm?.code} name="country">{elm?.name}</option>
                        ))}
                    </select>
                    : <span>{selectedCountry}</span>
                }
            </div>
            {readonly &&
                <>
                    <div className="form-input">
                        <label>Code postal</label>
                        <span>{zipcode}</span>
                    </div>
                    <div className="form-input">
                        <label>Ville</label>
                        <span>{city}</span>
                    </div>
                </>
            }
        </>
    );

    return (
        <>
            <legend className={legendView ? legendView : "no-legend"} ></legend>
            {readonly ?
                <div className="address-readonly-row">{addressFields}</div> :
                addressFields
            }
        </>
    )
}
